//   { label: "Showing 25 rows", value: "25" },
//   { label: "Showing 50 rows", value: "50" },
//   { label: "Showing 100 rows", value: "100" },
// ];

const selectOpionGenerator = (selectList, limit) => {
  let updatedList = [...selectList];

  if (limit && !updatedList.includes(Number(limit))) {
    // Find the correct position to insert the limit
    let insertIndex = 0;
    while (
      insertIndex < updatedList.length &&
      updatedList[insertIndex] < limit
    ) {
      insertIndex++;
    }

    // Insert the limit at the correct position
    updatedList.splice(insertIndex, 0, limit);
  }

  // Map the updated list to the required format
  return updatedList.map((item) => ({
    label: `Showing ${item} rows`,
    value: item,
  }));
};

export default selectOpionGenerator;
